// extracted by mini-css-extract-plugin
export default {"button":"link-small__button___j-9nV link__button___3l2Cw base__button___zT0JW"};